import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// La confirmación destructiva canónica de Gestión (la de borrar empresa
// externa y plantilla de recorrido): misma estructura y estilos, otro texto.
import {
  ModalContainerStyled,
  ContainerLoader,
  Container,
  ContainerText,
  Title,
  CompanyName as GroupName,
  Text,
  ButtonRow,
  ActionButton,
} from '../DeleteExternalCompanyModal/styles';

import { ModalProps } from './types';

import { Loader } from '../../../inputs/Loader';
import { AlertIcon } from '../../../../assets/icons/AlertIcon';

export const DeleteUserGroupModal = ({
  onClickClose,
  groupName,
  onConfirmDelete,
  isLoading: isLoadingProp,
  ...props
}: ModalProps): JSX.Element => {
  const { t } = useTranslation(['management', 'common']);
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(isLoadingProp || false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      await onConfirmDelete();
      onClickClose();
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainerStyled
      width={50}
      onClickClose={onClickClose}
      fill={theme.colors.black}
    >
      {isLoading && (
        <ContainerLoader>
          <Loader />
        </ContainerLoader>
      )}
      {/* Diálogo con nombre propio: los E2E no confunden su «Eliminar» con la
          papelera de cada fila de la tabla. */}
      <Container
        {...props}
        role="dialog"
        aria-modal="true"
        aria-label={t('management:groups.deleteConfirmation')}
        isLoading={isLoading}
      >
        <AlertIcon />

        <ContainerText>
          <Title variant="semiBold">
            {t('management:groups.deleteConfirmation')}
          </Title>
          <GroupName variant="semiBold">{groupName}</GroupName>
          <Text size="M" colorText="greyDark">
            {t('management:groups.deleteWarning')}
          </Text>
        </ContainerText>

        <ButtonRow>
          <ActionButton
            type="button"
            text={t('common:buttons.cancel')}
            variant="secondary"
            onClick={onClickClose}
            disabled={isLoading}
          />
          <ActionButton
            type="button"
            text={t('common:buttons.delete')}
            onClick={handleDelete}
            disabled={isLoading}
          />
        </ButtonRow>
      </Container>
    </ModalContainerStyled>
  );
};
